import {
  NotificationBar as CXNotificationBar,
  type NotificationBar as CXINotificationBar
} from '@sanlamcx/react-ui-next-notification-bar';

type NotificationBar = typeof CXNotificationBar;
export type INotificationBar = CXINotificationBar;
export const NotificationBar: NotificationBar = CXNotificationBar;
